import { React, forwardRef, useEffect, useState , useRef, useImperativeHandle} from 'react';
import { Button, Modal, Form, Container, Row, Col } from 'react-bootstrap';
import * as api from 'services/api';
import { useControlCentreContext } from 'contexts/ControlCentreContext';
import { useTranslation } from 'react-i18next';
const SetOverrideModal = forwardRef(

    function SetOverrideModal({ origin, destination, setOrigin, setDestination, show, handleShow, centreConfig}, ref) {
        const { t } = useTranslation();
        const { controlCentre } = useControlCentreContext();
        //#region ----------------------------- STATES -----------------
        const [error, setError] = useState(null);
        const [success, setSuccess] = useState(null);
        const [disableSaveButt, setDisableSaveButt] = useState(false);
        //#endregion

        //#region ----------------------------- EFFECTS ----------------
        //#endregion

        //#region ---------------------------- HANDLERS ----------------

        const handleSubmit = async () => {
            setError(null);
            setSuccess(null);
            try {
                const response = await api.setControlCentrePseudocodeConfig(controlCentre.centreid,centreConfig);
                if (response.status === 200 && response.data === true) {
                    setSuccess(t('ccPseudoCodeAssociated'));
                    setDisableSaveButt(true);
                    setOrigin({...origin, pseudoCodeId: ''});
                    setDestination({...destination, pseudoCodeId : ''})
                }
                if (response.data === false) {
                    setError(t('ccErrorNotSaved'));
                }
            } catch (error) {
                setError(t('ccErrorNotSaved'));
            }
        }

        const handleCloseModal = () => {
            handleShow(false);
            setDisableSaveButt(false);
            setError(null);
            setSuccess(null);
        }
        //#endregion
        return (
            <Modal show={show} onHide={handleCloseModal}
                ref={ref}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        {t('ccPseudoCodeAdd')}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Container>
                            <Row>
                                <Col><h3>{t('ccPseudoCodeOrigin')}</h3></Col>
                                <Col><h3>{t('ccPseudoCodeDestination')}</h3></Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form.Group className="mb-3" controlId="controlcentreid">
                                        <Form.Label>{t('ccControlCentre')} </Form.Label>
                                        <Form.Control
                                            type="text"
                                            value={controlCentre.centrename}
                                            disabled
                                        />
                                    </Form.Group>
                                </Col>
                                <Col>

                                    <Form.Group className="mb-3" controlId="controlcentreid">
                                        <Form.Label>{t('ccControlCentre')}</Form.Label>
                                        <Form.Control
                                            type="text"
                                            value={controlCentre.centrename}
                                            disabled
                                        />
                                    </Form.Group>
                                </Col>

                            </Row>
                            <Row>
                                <Col>
                                    <Form.Group className="mb-3" controlId="pseudotext">
                                        <Form.Label>{t('ccPseudoCodeText')}</Form.Label>
                                        <Form.Control type="text" value={origin.pseudoCodeText} disabled />
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group className="mb-3" controlId="pseudotext">
                                        <Form.Label>{t('ccPseudoCodeText')}</Form.Label>
                                        <Form.Control type="text" value={destination.pseudoCodeText} disabled />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form.Group className="mb-3" controlId="pseudodescrip">
                                        <Form.Label>{t('ccPseudoCodeDescription')} </Form.Label>
                                        <Form.Control type="text" value={origin.pseudoCodeDescription} disabled />
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group className="mb-3" controlId="pseudodescrip">
                                        <Form.Label>{t('ccPseudoCodeDescription')} </Form.Label>
                                        <Form.Control type="text" value={destination.pseudoCodeDescription} disabled />
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Row>
                                <Col>
                                    <Form.Group className="mb-3" controlId="pseudo">
                                        <Form.Label>{t('ccPseudoCode')} </Form.Label>
                                        <Form.Control type="text" value={origin.pseudoCode} disabled />
                                    </Form.Group>
                                </Col>
                                <Col>

                                    <Form.Group className="mb-3" controlId="pseudo">
                                        <Form.Label>{t('ccPseudoCode')} </Form.Label>
                                        <Form.Control type="text" value={destination.pseudoCode} disabled />
                                    </Form.Group>

                                </Col>

                            </Row>
                            <Row>
                                <Col>
                                    <Form.Group className="mb-3" controlId="pseudoid">
                                        <Form.Label>{t('ccPseudoCodeOrigin')}</Form.Label>
                                        <Form.Control type="text" value={origin.pseudoCodeId} disabled />
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Label>{t('ccPseudoCodeDestination')} </Form.Label>
                                    <Form.Control
                                        type="text"
                                        disabled
                                        name='OverrideCodeId'
                                        value={destination.pseudoCodeId}
                                        autoFocus
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                </Col>
                                <Col>
                                    <Form.Label>{t('ccLockTime')}</Form.Label>
                                    <Form.Control type="text" name='BlockingTime' disabled value={centreConfig.BlockingTimeSet[0] + ' mins'} />
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    {error && <p className="mt-3 text-danger fw-semibold">{error}</p>}
                                    {success && <p className='mt-3 text-success fw-semibold'>{success}</p>}
                                </Col>
                            </Row>
                        </Container>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant='light' onClick={handleCloseModal}>{t('ccClose')}</Button>
                    <Button variant="primary" disabled={disableSaveButt} onClick={handleSubmit}>{t('ccSave')}</Button>
                </Modal.Footer>
            </Modal>
        );
    })

    export default SetOverrideModal;